import { observable, computed } from "mobx";

export interface RuleDefinition {
    id: number;
    name: string;
    description: string;
    tableName: string;
    ruleValues: string[];
}

export class RuleStore {

    /**
     * These are the categories that we know how to fetch from the DB
     */

    @observable rules: RuleDefinition[] = [];

    load(rules: RuleDefinition[]) {
        if (rules) this.rules = rules;
    }

    @computed get all() {
        return this.rules;
    }
}

export default new RuleStore();